// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - SNACKBAR ||============================== //

export default function Snackbar(theme: Theme) {
  return {
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          // Don't override notistack styled snackbars - they have their own styling
          // Only apply to non-notistack snackbars (without notistack-MuiContent class)
          '&:not([class*="notistack"])': {
            color: theme.palette.common.white,
            '& .MuiSnackbarContent-message': {
              color: theme.palette.common.white
            }
          }
        }
      }
    }
  };
}
